<template>
    <div class="recap-step2">
        <h4>Récapitulatif</h4>
        <div class="">
            <div class="recap-amounts">
                <div v-for="prestation in selected_prestations" :key="prestation.prestation_id" class="recap-amount">
                    <h5>{{prestation.fo_name || prestation.bo_name}}</h5>
                    <h5>{{!this.config.display_price || !prestation.display_price ? "" : formatPrice(prestation.price)}}</h5>
                    <svg v-if="can_modify" @click="handleClick(prestation.prestation_id)" style="cursor: pointer;" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="13" cy="13" r="12" fill="#FBBC00" stroke="white" stroke-width="2"/>
                        <path d="M13 13.9329L9.73337 17.1995C9.61114 17.3218 9.45559 17.3829 9.2667 17.3829C9.07781 17.3829 8.92225 17.3218 8.80003 17.1995C8.67781 17.0773 8.6167 16.9218 8.6167 16.7329C8.6167 16.544 8.67781 16.3884 8.80003 16.2662L12.0667 12.9995L8.80003 9.73288C8.67781 9.61066 8.6167 9.4551 8.6167 9.26621C8.6167 9.07732 8.67781 8.92177 8.80003 8.79954C8.92225 8.67732 9.07781 8.61621 9.2667 8.61621C9.45559 8.61621 9.61114 8.67732 9.73337 8.79954L13 12.0662L16.2667 8.79954C16.3889 8.67732 16.5445 8.61621 16.7334 8.61621C16.9223 8.61621 17.0778 8.67732 17.2 8.79954C17.3223 8.92177 17.3834 9.07732 17.3834 9.26621C17.3834 9.4551 17.3223 9.61066 17.2 9.73288L13.9334 12.9995L17.2 16.2662C17.3223 16.3884 17.3834 16.544 17.3834 16.7329C17.3834 16.9218 17.3223 17.0773 17.2 17.1995C17.0778 17.3218 16.9223 17.3829 16.7334 17.3829C16.5445 17.3829 16.3889 17.3218 16.2667 17.1995L13 13.9329Z" fill="white"/>
                    </svg>
                </div>
            </div>
            <div class="total-recap" v-if="total_amount != 0">
                <h5>Total <span>{{formatPrice(total_amount)}}</span></h5>
            </div>
        </div>
        <div class="recup-infos">
            <h5>
                <svg width="22" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2ZM10 4C10.2449 4.00003 10.4813 4.08996 10.6644 4.25272C10.8474 4.41547 10.9643 4.63975 10.993 4.883L11 5V9.586L13.707 12.293C13.8863 12.473 13.9905 12.7144 13.9982 12.9684C14.006 13.2223 13.9168 13.4697 13.7488 13.6603C13.5807 13.8508 13.3464 13.9703 13.0935 13.9944C12.8406 14.0185 12.588 13.9454 12.387 13.79L12.293 13.707L9.293 10.707C9.13758 10.5514 9.03776 10.349 9.009 10.131L9 10V5C9 4.73478 9.10536 4.48043 9.29289 4.29289C9.48043 4.10536 9.73478 4 10 4Z" fill="#656565"/>
                </svg>
                <span>{{getDuration}}</span>
            </h5>
            <h5 v-if="start_date && start_hour">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 14C17.2652 14 17.5196 13.8946 17.7071 13.7071C17.8946 13.5196 18 13.2652 18 13C18 12.7348 17.8946 12.4804 17.7071 12.2929C17.5196 12.1054 17.2652 12 17 12C16.7348 12 16.4804 12.1054 16.2929 12.2929C16.1054 12.4804 16 12.7348 16 13C16 13.2652 16.1054 13.5196 16.2929 13.7071C16.4804 13.8946 16.7348 14 17 14ZM17 18C17.2652 18 17.5196 17.8946 17.7071 17.7071C17.8946 17.5196 18 17.2652 18 17C18 16.7348 17.8946 16.4804 17.7071 16.2929C17.5196 16.1054 17.2652 16 17 16C16.7348 16 16.4804 16.1054 16.2929 16.2929C16.1054 16.4804 16 16.7348 16 17C16 17.2652 16.1054 17.5196 16.2929 17.7071C16.4804 17.8946 16.7348 18 17 18ZM13 13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13C11 12.7348 11.1054 12.4804 11.2929 12.2929C11.4804 12.1054 11.7348 12 12 12C12.2652 12 12.5196 12.1054 12.7071 12.2929C12.8946 12.4804 13 12.7348 13 13ZM13 17C13 17.2652 12.8946 17.5196 12.7071 17.7071C12.5196 17.8946 12.2652 18 12 18C11.7348 18 11.4804 17.8946 11.2929 17.7071C11.1054 17.5196 11 17.2652 11 17C11 16.7348 11.1054 16.4804 11.2929 16.2929C11.4804 16.1054 11.7348 16 12 16C12.2652 16 12.5196 16.1054 12.7071 16.2929C12.8946 16.4804 13 16.7348 13 17ZM7 14C7.26522 14 7.51957 13.8946 7.70711 13.7071C7.89464 13.5196 8 13.2652 8 13C8 12.7348 7.89464 12.4804 7.70711 12.2929C7.51957 12.1054 7.26522 12 7 12C6.73478 12 6.48043 12.1054 6.29289 12.2929C6.10536 12.4804 6 12.7348 6 13C6 13.2652 6.10536 13.5196 6.29289 13.7071C6.48043 13.8946 6.73478 14 7 14ZM7 18C7.26522 18 7.51957 17.8946 7.70711 17.7071C7.89464 17.5196 8 17.2652 8 17C8 16.7348 7.89464 16.4804 7.70711 16.2929C7.51957 16.1054 7.26522 16 7 16C6.73478 16 6.48043 16.1054 6.29289 16.2929C6.10536 16.4804 6 16.7348 6 17C6 17.2652 6.10536 17.5196 6.29289 17.7071C6.48043 17.8946 6.73478 18 7 18Z" fill="#656565"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99998 1.75C7.19889 1.75 7.38965 1.82902 7.53031 1.96967C7.67096 2.11032 7.74998 2.30109 7.74998 2.5V3.263C8.41198 3.25 9.14098 3.25 9.94298 3.25H14.056C14.859 3.25 15.588 3.25 16.25 3.263V2.5C16.25 2.30109 16.329 2.11032 16.4696 1.96967C16.6103 1.82902 16.8011 1.75 17 1.75C17.1989 1.75 17.3897 1.82902 17.5303 1.96967C17.671 2.11032 17.75 2.30109 17.75 2.5V3.327C18.01 3.347 18.2563 3.37233 18.489 3.403C19.661 3.561 20.61 3.893 21.359 4.641C22.107 5.39 22.439 6.339 22.597 7.511C22.75 8.651 22.75 10.106 22.75 11.944V14.056C22.75 15.894 22.75 17.35 22.597 18.489C22.439 19.661 22.107 20.61 21.359 21.359C20.61 22.107 19.661 22.439 18.489 22.597C17.349 22.75 15.894 22.75 14.056 22.75H9.94498C8.10698 22.75 6.65098 22.75 5.51198 22.597C4.33998 22.439 3.39098 22.107 2.64198 21.359C1.89398 20.61 1.56198 19.661 1.40398 18.489C1.25098 17.349 1.25098 15.894 1.25098 14.056V11.944C1.25098 10.106 1.25098 8.65 1.40398 7.511C1.56198 6.339 1.89398 5.39 2.64198 4.641C3.39098 3.893 4.33998 3.561 5.51198 3.403C5.74531 3.37233 5.99164 3.347 6.25098 3.327V2.5C6.25098 2.30126 6.32986 2.11065 6.47029 1.97002C6.61073 1.8294 6.80124 1.75026 6.99998 1.75ZM5.70998 4.89C4.70498 5.025 4.12498 5.279 3.70198 5.702C3.27898 6.125 3.02498 6.705 2.88998 7.71C2.86731 7.88 2.84798 8.05967 2.83198 8.249H21.168C21.152 8.05967 21.1326 7.87967 21.11 7.709C20.975 6.704 20.721 6.124 20.298 5.701C19.875 5.278 19.295 5.024 18.289 4.889C17.262 4.751 15.907 4.749 14 4.749H9.99998C8.09298 4.749 6.73898 4.752 5.70998 4.89ZM2.74998 12C2.74998 11.146 2.74998 10.403 2.76298 9.75H21.237C21.25 10.403 21.25 11.146 21.25 12V14C21.25 15.907 21.248 17.262 21.11 18.29C20.975 19.295 20.721 19.875 20.298 20.298C19.875 20.721 19.295 20.975 18.289 21.11C17.262 21.248 15.907 21.25 14 21.25H9.99998C8.09298 21.25 6.73898 21.248 5.70998 21.11C4.70498 20.975 4.12498 20.721 3.70198 20.298C3.27898 19.875 3.02498 19.295 2.88998 18.289C2.75198 17.262 2.74998 15.907 2.74998 14V12Z" fill="#656565"/>
                    </svg>
                    <span v-if="freetimeTitle && config['DISPLAY_FREETIME_TITLE_FO'] == 1">
                    {{ formatDateMoment(start_date, 'DD/MM/YYYY') }} à {{ freetimeTitle }}
                    </span>
                    <span v-else>
                        {{ formatDateMoment(start_date, 'DD/MM/YYYY') }} à {{ start_hour }}
                    </span>
            </h5>
            <h5>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.2715 10.2723C16.2715 11.3332 15.8501 12.3506 15.0999 13.1008C14.3498 13.8509 13.3324 14.2723 12.2715 14.2723C11.2106 14.2723 10.1932 13.8509 9.44306 13.1008C8.69291 12.3506 8.27148 11.3332 8.27148 10.2723C8.27148 9.21147 8.69291 8.19406 9.44306 7.44391C10.1932 6.69377 11.2106 6.27234 12.2715 6.27234C13.3324 6.27234 14.3498 6.69377 15.0999 7.44391C15.8501 8.19406 16.2715 9.21147 16.2715 10.2723ZM14.2715 10.2723C14.2715 10.8028 14.0608 11.3115 13.6857 11.6866C13.3106 12.0616 12.8019 12.2723 12.2715 12.2723C11.7411 12.2723 11.2323 12.0616 10.8573 11.6866C10.4822 11.3115 10.2715 10.8028 10.2715 10.2723C10.2715 9.74191 10.4822 9.2332 10.8573 8.85813C11.2323 8.48305 11.7411 8.27234 12.2715 8.27234C12.8019 8.27234 13.3106 8.48305 13.6857 8.85813C14.0608 9.2332 14.2715 9.74191 14.2715 10.2723Z" fill="#656565"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.794 16.518C4.50484 15.2905 3.60861 13.7084 3.21864 11.9716C2.82867 10.2348 2.96248 8.42137 3.60315 6.76062C4.24381 5.09987 5.36256 3.6664 6.81792 2.64148C8.27328 1.61656 9.99988 1.04622 11.7794 1.00258C13.5589 0.958949 15.3114 1.44398 16.8152 2.39634C18.3191 3.3487 19.5067 4.72562 20.228 6.35297C20.9493 7.98032 21.1718 9.78501 20.8675 11.5388C20.5631 13.2927 19.7455 14.9168 18.518 16.206L12.312 22.724L5.794 16.518ZM17.07 14.827L12.243 19.897L7.173 15.07C6.17037 14.1153 5.47334 12.8848 5.17005 11.5339C4.86676 10.1831 4.97084 8.77273 5.46912 7.48107C5.9674 6.1894 6.8375 5.0745 7.96941 4.27734C9.10131 3.48017 10.4442 3.03655 11.8282 3.00257C13.2122 2.96859 14.5752 3.34577 15.7449 4.08643C16.9146 4.82708 17.8383 5.89794 18.3994 7.16359C18.9605 8.42924 19.1336 9.83285 18.897 11.1969C18.6604 12.561 18.0246 13.8242 17.07 14.827Z" fill="#656565"/>
                    </svg>
                <span>{{location?.name}} <br>{{renderLocationAddress}}</span>
            </h5>
        </div>
        <div v-if="Object.keys(rdvs).length > 0"><h5>Créneaux selectionnés</h5></div>
        <div v-for="(rdv, key) in rdvs" :key="'recap-r'+rdv.rdv_id"
            class="recap-start-dates">
            <h5>
                <span v-if="rdv.free_time && rdv.free_time_title && config['DISPLAY_FREETIME_TITLE_FO'] == 1">
                    {{ formatDateMoment(rdv.start_date, 'DD/MM/YYYY') }} à {{ rdv.free_time.title }}
                </span>
                <span v-else>
                    {{format_date_from_rdv(rdv)}}
                </span>
            </h5>
            <svg v-if="can_unselect && unselect_ordered(rdv)" @click="unselect(rdv, key)" style="cursor: pointer;" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="13" cy="13" r="12" fill="#FBBC00" stroke="white" stroke-width="2"/>
                <path d="M13 13.9329L9.73337 17.1995C9.61114 17.3218 9.45559 17.3829 9.2667 17.3829C9.07781 17.3829 8.92225 17.3218 8.80003 17.1995C8.67781 17.0773 8.6167 16.9218 8.6167 16.7329C8.6167 16.544 8.67781 16.3884 8.80003 16.2662L12.0667 12.9995L8.80003 9.73288C8.67781 9.61066 8.6167 9.4551 8.6167 9.26621C8.6167 9.07732 8.67781 8.92177 8.80003 8.79954C8.92225 8.67732 9.07781 8.61621 9.2667 8.61621C9.45559 8.61621 9.61114 8.67732 9.73337 8.79954L13 12.0662L16.2667 8.79954C16.3889 8.67732 16.5445 8.61621 16.7334 8.61621C16.9223 8.61621 17.0778 8.67732 17.2 8.79954C17.3223 8.92177 17.3834 9.07732 17.3834 9.26621C17.3834 9.4551 17.3223 9.61066 17.2 9.73288L13.9334 12.9995L17.2 16.2662C17.3223 16.3884 17.3834 16.544 17.3834 16.7329C17.3834 16.9218 17.3223 17.0773 17.2 17.1995C17.0778 17.3218 16.9223 17.3829 16.7334 17.3829C16.5445 17.3829 16.3889 17.3218 16.2667 17.1995L13 13.9329Z" fill="white"/>
            </svg>
        </div>
        <div v-if="config.hasOwnProperty('SHOW_AGENDA_IMG_ONLINE-' + store.selected_agenda?.agenda_id) 
                    && config['SHOW_AGENDA_IMG_ONLINE-'+store.selected_agenda?.agenda_id] == 1" 
                    id="agenda_img_container" class="d-flex justify-content-center">
            <img :src="config['agendas_logo_url']+store.selected_agenda.image" class="w-100" alt="">
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { toRaw } from 'vue';
import { BookingStore } from '../Stores/BookingStore';

export default{
    name: 'AppointmentSummary',
    props: {
        config:{}, prestations:{}, group_size: {type: Number, default: 1},
        location:{},price:{}, start_date: {}, day: {}, hour: {}, start_hour: {},
        rdvs: {}, freetimeTitle:{type: String, default: ''}, can_unselect:Boolean, can_select_number:Number, selected_free_time: Object
    },
    emits: ['back','unselected'],
    data () {
        return {
            selected_prestations: this.prestations,
            store: BookingStore
        }
    },
    computed: {
        can_modify(){
            return !BookingStore.rdvToModify;
        },
        total_amount() {
            let sum = 0;
            for (const presta of this.prestations) {
                sum += presta.price;
            }
            return sum*this.group_size;
        },
        getDuration () {
            if (
                !this.config.display_duration
                ||
                this.prestations.find(prestation => !prestation.display_duration)
            ) return 'Durée non communiquée'

            let duration = this.prestations.reduce((accumulator, prestation) => accumulator += prestation.duration, 0)
            let hours = Math.floor(duration / 60)
            let minutes = duration % 60
            if (minutes < 10 && minutes != 0) minutes = '0' + minutes
            let str = ''
            if (hours) str += hours + 'h'
            if (minutes) str += minutes + ' minutes'
            return str
        },
        renderLocationAddress() {
            if (!this.location?.address) return ''
            let localisation_regex = /((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)/
            return this.location.address.split(' ').filter(elt => !elt.match(localisation_regex)).join(' ')
        },
    },
    mounted(){
        // console.log('AppointmentSummary mounted - rdvs:');
        // console.log('AppointmentSummary mounted - selected_free_time:', this.selected_free_time);
    },
    methods: {
        getTimeSlotDisplay() {
            // For single RDV: use selected_free_time
            if (this.freetimetitle ) {
                return this.freetimetitle;
            }
            return this.start_hour;
        },
        formatPrice(price) {
            let val
            val = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(price)
            return (val)
        },
        format_date_from_rdv(rdv){
            return moment(`${rdv.start_date} ${rdv.heure || '00:00'}`).format('DD/MM/YYYY à HH:mm');
        },
        handleClick(prestation_id) {
            if (this.prestations.length === 1) {
                this.$emit('back')
            }
            this.removePrestation(prestation_id)
            // console.log(BookingStore.selected_prestations);
        },
        removePrestation(prestation_id) {
            this.selected_prestations = this.selected_prestations.filter(
            (presta) => prestation_id != presta.prestation_id
            );
            BookingStore.selected_prestations = this.selected_prestations
        },
        unselect(rdv, key){
            rdv.start = key;
            // console.log('summary unselect',rdv);
            this.$emit('unselected',rdv);
        },
        unselect_ordered(rdv){
            let is_ordered = true;
            // Déjà ordonné si multiple rdv désactivé ou ordre désactivé
            if(this.config['MULTIPLE_RDV'] == 0 || this.config['MULTIPLE_RDV_ORDER'] == 'NONE' || this.config['SLOT_IMPOSITION_FROM'] > this.can_select_number){
                return is_ordered;
            }            
            // Vérifier si dernier créneau sélectionné correspond
            // console.log('AppointmentSummary unselect_ordered',(rdv.day+' '+rdv.heure+':00'),Object.keys(this.rdvs)[Object.keys(this.rdvs).length - 1],rdv,this.rdvs);
             
            if((rdv.day+' '+rdv.heure+':00') == Object.keys(this.rdvs)[Object.keys(this.rdvs).length - 1]){
                is_ordered = true;
            }else{
                is_ordered = false
            }
            return is_ordered;
        },
        formatDateMoment(date, format) {
            return date ? moment(date).locale('fr').format(format) : '';
        },
    }
}
</script>

<style>

.recap-step2 .recap-amount{
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--third-color);
    border: 3px solid var(--primary-color);
    border-radius: 15px;
    padding: 16px 15px;
    margin: 15px 0;
    position: relative;
}
.recap-step2 .recap-amount svg{
    position: absolute;
    right: -10px;
    top: -10px;
    cursor: pointer;
}

.recap-step2 .recap-amount h5 {
    font-weight: 700;
    font-size: 16px;
}

.recap-step2 .recap-start-dates{
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--third-color);
    border: 3px solid var(--primary-color);
    border-radius: 15px;
    padding: 16px 15px;
    margin: 15px 0;
    position: relative;
}
.recap-step2 .recap-start-dates svg{
    position: absolute;
    right: -10px;
    top: -10px;
    cursor: pointer;
}

.recap-step2 .recap-start-dates h5 {
    font-weight: 700;
    font-size: 16px;
}

#agenda_img_container img{
    max-width: 128px;
}

</style>